import React, { useState } from 'react'
import style from './Products.module.scss'
import { useTranslation } from 'react-i18next'

export default function Products() {
    const { t } = useTranslation();
    
    const productCategories = [
        {
            titleKey: 'products.categories.chemicals.title',
            descriptionKey: 'products.categories.chemicals.description',
            itemsKey: 'products.categories.chemicals.items',
            icon: 'fa-flask-vial'
        },
        {
            titleKey: 'products.categories.fibers.title',
            descriptionKey: 'products.categories.fibers.description',
            itemsKey: 'products.categories.fibers.items',
            icon: 'fa-shirt'
        },
        {
            titleKey: 'products.categories.agricultural.title',
            descriptionKey: 'products.categories.agricultural.description',
            itemsKey: 'products.categories.agricultural.items',
            icon: 'fa-wheat-awn'
        }
    ]

    let myObj = [
        {
            path: '/images/hcl.jpg',
            titleKey: 'products.items.hcl.title',
            FOB: t('products.items.hcl.fob'),
            Quantity: t('products.items.hcl.quantity'),
            Ability: t('products.items.hcl.ability'),
            Port: t('products.items.hcl.port'),
            Purity: t('products.items.hcl.purity'),
            specifications: {
                molecularFormula: t('products.items.hcl.specifications.molecularFormula'),
                grade: t('products.items.hcl.specifications.grade'),
                casNumber: t('products.items.hcl.specifications.casNumber'),
                packaging: t('products.items.hcl.specifications.packaging')
            },
            description: {
                overview: t('products.items.hcl.description.overview'),
                applications: t('products.items.hcl.description.applications', { returnObjects: true }),
                safetyNote: t('products.items.hcl.description.safetyNote')
            }
        },
        {
            path: './images/1-Calcium_Carbonate20150602_012613.jpg',
            titleKey: 'products.items.calcium.title',
            FOB: t('products.items.calcium.fob'),
            Quantity: t('products.items.calcium.quantity'),
            Ability: t('products.items.calcium.ability'),
            Port: t('products.items.calcium.port'),
            Purity: t('products.items.calcium.purity')
        },
        {
            path: './images/4-Magnesium_Oxide_80.jpg',
            titleKey: 'products.items.magnesium.title',
            FOB: t('products.items.magnesium.fob'),
            Quantity: t('products.items.magnesium.quantity'),
            Ability: t('products.items.magnesium.ability'),
            Port: t('products.items.magnesium.port'),
            Purity: t('products.items.magnesium.purity')
        }
    ]

    let [myInfo, setInfo] = useState(' ')

    let getData = (element) => {
        setInfo(element)
    }

    return (
        <section id="product">
            <div className={`${style.products}`}>
                <div className="container">
                    <div className={`${style.title}`}>
                        <h2>{t('products.title')}</h2>
                        <p>{t('products.subtitle')}</p>
                    </div>

                    {/* Product Categories Section */}
                    <div className={`${style.categories} mb-5`}>
                        <div className="row">
                            {productCategories.map((category, index) => (
                                <div className="col-lg-4 col-md-6 mb-4" key={index}>
                                    <div className={style.categoryCard}>
                                        <div className={style.iconWrapper}>
                                            <i className={`fa-solid ${category.icon}`}></i>
                                        </div>
                                        <h3>{t(category.titleKey)}</h3>
                                        <p>{t(category.descriptionKey)}</p>
                                        <ul>
                                            {t(category.itemsKey, { returnObjects: true }).map((item, itemIndex) => (
                                                <li key={itemIndex}>{item}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Individual Products Section */}
                    <div className={`${style.title} mt-5`}>
                        <h2>{t('products.featured.title')}</h2>
                        <p>{t('products.featured.subtitle')}</p>
                    </div>
                    <div className="row">
                        {myObj.map((item, index) => (
                            <div className="col-lg-3" key={index}>
                                <div className={`${style.item}`}>
                                    <img src={item.path} alt={t(item.titleKey)} className="w-100" />
                                    <h3 className={`${style.Itemtitle}`}>{t(item.titleKey)}</h3>
                                    <div className={`${style.ItemBtn}`}>
                                        <i
                                            className="fa-regular fa-eye"
                                            onClick={() => getData(item)}
                                            data-bs-toggle="modal"
                                            data-bs-target="#staticBackdrop"
                                        ></i>
                                        <a href="/" className={`${style.Btn}`}>
                                            <i className="fa-brands fa-whatsapp"></i>{' '}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Modal */}
                    <div
                        className={`${style.Modal} modal fade`}
                        id="staticBackdrop"
                        data-bs-backdrop="static"
                        data-bs-keyboard="false"
                        tabIndex={-1}
                        aria-labelledby="staticBackdropLabel"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog modal-xl">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h1 className={`${style.modalTitle} modal-title fs-5`} id="staticBackdropLabel">
                                        {t(myInfo.titleKey)}
                                    </h1>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label={t('common.close')}
                                    />
                                </div>
                                <div className={`${style.body} modal-body`}>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <img
                                                src={myInfo.path}
                                                alt={t(myInfo.titleKey)}
                                                className={`${style.modalImg} w-100`}
                                            />
                                            <button className={`${style.downloadBtns} btn btn-primary`}>
                                                <i className="fa-solid fa-download"></i>{t('products.modal.downloadSpecs')}
                                            </button>
                                            <button className={`${style.downloadBtns} btn btn-primary`}>
                                                {t('products.modal.inquiry')}
                                            </button>
                                        </div>
                                        <div className="col-lg-6">
                                            <h4 className="mb-3">{t('products.modal.specifications')}</h4>
                                            {myInfo.specifications && (
                                                <div className="mb-4">
                                                    <p>{t('products.modal.molecularFormula')}: <span>{myInfo.specifications.molecularFormula}</span></p>
                                                    <p>{t('products.modal.grade')}: <span>{myInfo.specifications.grade}</span></p>
                                                    <p>{t('products.modal.casNumber')}: <span>{myInfo.specifications.casNumber}</span></p>
                                                    <p>{t('products.modal.packaging')}: <span>{myInfo.specifications.packaging}</span></p>
                                                </div>
                                            )}
                                            <h4 className="mb-3">{t('products.modal.details')}</h4>
                                            <p>{t('products.modal.fob')}: <span>{myInfo.FOB}</span></p>
                                            <p>{t('products.modal.quantity')}: <span>{myInfo.Quantity}</span></p>
                                            <p>{t('products.modal.ability')}: <span>{myInfo.Ability}</span></p>
                                            <p>{t('products.modal.port')}: <span>{myInfo.Port}</span></p>
                                            <p>{t('products.modal.purity')}: <span>{myInfo.Purity}</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
